import React from "react"
import { TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody, FontIcon } from "material-ui"
import strings from "../../../../../localization/strings"
import Table from "../../../../../components/common/Table"
import { IWorkPoolEmployee } from "../../../../../models"
import { green500 } from "material-ui/styles/colors"
import * as jobHelper from "../../../../../helpers/jobHelper"

interface IProps {
    readonly: boolean
    workPoolEmployees: IWorkPoolEmployee[]
    selectedEmployees: IWorkPoolEmployee[]
    total: number
    offset: number
    limit: number
    limitOptions: number[]
    onPageClick(offset: number): void
    onLimitChange(limit: number): void
    handleSelect(selectedEmployees: IWorkPoolEmployee[]): void
}

const ShortlistSelectionTable: React.SFC<IProps> = (props: IProps) => {

    const missingBadges = (missingBadges) => {
        if (missingBadges && !missingBadges.length) {
            return (
                <div>
                    <FontIcon className="fa fa-check" style={{ fontSize: 18, color: green500 }} />
                    <span style={{ paddingLeft: 5, color: green500 }}>{strings.None}</span>
                </div>
            )
        } else if (missingBadges && missingBadges.length === 1) return missingBadges[0]
        else if (missingBadges && missingBadges.length > 1) return missingBadges.join(", ")
    }

    const specialties = (specialities) => {
        if (!specialities) {
            return null
        } else if (specialities && specialities.length === 1) return specialities[0]
        else if (specialities && specialities.length > 1) return specialities.join(", ")
    }


    return (
        <Table
            readonly={props.readonly}
            allowClickRow
            items={props.workPoolEmployees}
            handleSelect={props.handleSelect}
            total={props.total}
            offset={props.offset}
            limit={props.limit}
            limitOptions={props.limitOptions}
            onPageClick={props.onPageClick}
            onLimitChange={props.onLimitChange}
        >
            <TableHeader>
                <TableRow>
                    <TableHeaderColumn style={{ textAlign: "left" }}>{strings.Name}</TableHeaderColumn>
                    <TableHeaderColumn style={{ textAlign: "left" }}>{strings.Missing_Badges}</TableHeaderColumn>
                    <TableHeaderColumn style={{ textAlign: "left" }}>{strings.Miles}</TableHeaderColumn>
                    <TableHeaderColumn style={{textAlign:"left"}}>{strings.Specialties}</TableHeaderColumn>
                    <TableHeaderColumn style={{textAlign:"left"}}>{strings.Occupations}</TableHeaderColumn>
                    <TableHeaderColumn style={{ textAlign: "left" }}>{strings.Available}</TableHeaderColumn>
                </TableRow>
            </TableHeader>
            <TableBody showRowHover={true} deselectOnClickaway={false}>
                {props.workPoolEmployees.map((employee: IWorkPoolEmployee, key) =>
                    <TableRow
                        key={key}
                        selected={props.selectedEmployees.find(item => item.Id === employee.Id) ? true : false}
                    >
                        <TableRowColumn title={employee.EmployeeName} style={{ textAlign: "left", cursor: "pointer" }}>{employee.EmployeeName}</TableRowColumn>
                        <TableRowColumn title={employee.MissingBadgeNames} style={{ textAlign: "left", cursor: "pointer" }}>{missingBadges(employee.MissingBadgeNames)}</TableRowColumn>
                        <TableRowColumn style={{ textAlign: "left", cursor: "pointer" }}>{jobHelper.getMilesFromClient(employee.MilesFromClient)}</TableRowColumn>
                        <TableRowColumn title={employee.Specialities} style={{ textAlign: "left"}}>{specialties(employee.Specialities)}</TableRowColumn>
                        <TableRowColumn title={employee.Occupation} style={{ textAlign: "left"}}>{employee.Occupation}</TableRowColumn>
                        <TableRowColumn style={{ textAlign: "left", cursor: "pointer" }}>
                            {employee.Available &&
                                <FontIcon className="fa fa-check" style={{ fontSize: 18, color: green500 }} />
                            }
                        </TableRowColumn>
                    </TableRow>
                )}
            </TableBody>
        </Table>
    )
}

export default ShortlistSelectionTable